    (function () {
      function openPrefs() {
        try {
          return !!(window._iub && _iub.cs && _iub.cs.api && typeof _iub.cs.api.openPreferences === 'function' && (_iub.cs.api.openPreferences(), true));
        } catch (e) {
          return false;
        }
      }

      function handlePrivacyChoices() {
        if (window.location.hash !== '#privacy-choices') return;

        history.replaceState(null, document.title, window.location.pathname + window.location.search);

        if (openPrefs()) return;

        let attempts = 0;
        const maxAttempts = 12;
        const timer = setInterval(function () {
          attempts++;
          if (openPrefs() || attempts >= maxAttempts) clearInterval(timer);
        }, 250);
      }

      document.addEventListener('click', function (e) {
        const link = e.target.closest && e.target.closest('a[href$="#privacy-choices"]');
        if (!link) return;
        e.preventDefault();
        window.location.hash = '#privacy-choices';
        handlePrivacyChoices();
      });

      window.addEventListener('hashchange', handlePrivacyChoices);
      document.addEventListener('DOMContentLoaded', handlePrivacyChoices);
    })();
